<template>
  <div>
    <h3 v-if="group !== '1'">Experimental settings</h3>
    <div class="setting" v-for="setting in textSettings">
      {{ setting.description }}
      <button @click="editTextSetting(setting.description, setting.key)">
        {{ settings[setting.key] }}
      </button>
    </div>
    <div class="setting" v-for="setting in boolSettings">
      <button @click="toggle(setting.key)" class="md-icon">
        {{ settings[setting.key] ? "check_box" : "check_box_outline_blank" }}
      </button>
      {{ setting.description }}
    </div>
    <button class="special" @click="switchGroup" />
  </div>
</template>

<style scoped>
.setting {
  display: flex;
  align-items: center;
  min-height: 40px;
  gap: 16px;
  margin-left: 16px;
}
button {
  min-height: 24px;
  padding: 4px 8px;
}
.setting button.md-icon {
  height: 30px;
  width: 30px;
  margin: 0;
  font-size: 24px;
}

button.special {
  width: 50px;
  height: 50px;
  position: fixed;
  bottom: 10px;
  right: 10px;
  cursor: auto;
}
button.special:hover {
  background-color: transparent;
}
</style>

<script>
import settings from "@/synced-settings";

export default {
  props: ["group"],
  data() {
    return {
      settings: settings,
    };
  },
  computed: {
    settingGroup() {
      return settings.config[this.group];
    },
    textSettings() {
      return this.settingGroup.filter((s) => s.type === "text");
    },
    boolSettings() {
      return this.settingGroup.filter((s) => s.type === "bool");
    },
  },
  methods: {
    editTextSetting(descr, key) {
      const value = window.prompt(descr, settings[key]);
      if (value) {
        settings[key] = value;
      }
    },
    toggle(key) {
      this.settings[key] = !this.settings[key];
    },
    switchGroup() {
      const newGroup = (this.group % 3) + 1;
      this.$router.safePush("/settings/" + newGroup);
    },
  },
};
</script>
